import React from "react";
import { cn } from "../../../../helpers/cn";

type ResetPasswordMiddleContainerProps = React.ComponentProps<"div">;

export const ResetPasswordMiddleContainer = ({
  children,
  className,
}: ResetPasswordMiddleContainerProps) => {
  return (
    <div className={cn("mt-8 flex flex-col space-y-6 w-[22rem] ", className)}>
      {children}
    </div>
  );
};
